import { render } from "./sparkle_icon.vue?vue&type=template&id=c84b3ca0"
import script from "./sparkle_icon.vue?vue&type=script&lang=js"
export * from "./sparkle_icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__